import { NextPageContext } from 'next'

export const isServerSideContext = (ctx: NextPageContext) => !!(ctx.req && ctx.res)
